module.exports = __webpack_public_path__ + "static/august-close-min-6c7ce6ca0aba3925d314a02ac3217df7.jpg";